import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryWrapper } from "./helpers";

export const projectApprovalApi = createApi({
  reducerPath: "projectApprovalApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "projects",
  }),
  endpoints: (build) => ({
    setApprovalStatus: build.mutation({
      query: ({ projectId, workflowStepId, status }) => ({
        url: `${projectId}/workflow/${workflowStepId}`,
        method: "POST",
        body: { status },
      }),
    }),
    getFlattenedApprovers: build.query({
      query: (projectId) => `${projectId}/approvers`,
      transformResponse: ({ data }) => data,
    }),
    getApprovalState: build.query({
      query: (projectId) => `${projectId}/approvals/state/`,
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const {
  useSetApprovalStatusMutation,
  useGetFlattenedApproversQuery,
  useGetApprovalStateQuery,
} = projectApprovalApi;
